module.exports = __webpack_public_path__ + "static/img/miPad3.8697d8dc.png";